import React, { Component } from "react";
import Hero from "../presentational/Hero";

class HeroHomeContainer extends Component {
	render() {
		return (
			<Hero className="left" fluid link="intro">
        <h1>New Skin in<br/><em> 5 Days</em></h1>
      </Hero>
		)
	}
}

export default HeroHomeContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/HeroHomeContainer.jsx
 **/